import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { hasRole } from "@/js/http/auth";
import PurchaseOrderForm from "@/components/purchase-orders/PurchaseOrderForm.vue";
import AdminInventorySubMenusLinks from "@/components/menu/sub-menus/inventory/AdminInventorySubMenusLinks.vue";
import Error from "@/views/error/error.vue";
export default {
  methods: {
    saveDraft: function saveDraft(isDraft) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    complete: function complete(isDraft) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  },
  components: {
    PurchaseOrderForm: PurchaseOrderForm,
    AdminInventorySubMenusLinks: AdminInventorySubMenusLinks,
    Error: Error
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      isForbiddenToAccessPage: false
    };
  },
  created: function created() {
    this.isForbiddenToAccessPage = !hasRole(process.env.VUE_APP_ROLES_MANAGE_PURCHASE_ORDERS);
    if (!this.$whitelabel.isAllowedToAccessPurchaseOrder) {
      this.$router.push({
        name: "home"
      });
    }
  }
};